import ArticleLayout from "@/components/feature/ArticleLayout";
import { articleDataList } from "@/mocks/articles";

export default function BestDealsPage() {
  const article = articleDataList.find((a) => a.slug === "mulebuy-spreadsheet-best-deals-2026")!;
  return <ArticleLayout article={article} />;
}